import WIDGETS from './widgets';

export default {
  name: 'activities_details_nyn',
  spacing: 0,
	direction: 'column',
  className: 'exclude_from_sidebar',
	widgets: [
		{ content: WIDGETS.GOBACKCOMMUNITY, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
    { content: WIDGETS.ACTIVITYLIST, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
	],
};
